import { styled } from "styled-components";

import { useDispatch, useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { CustomTopicGrid } from "domains/customTopicGrid/CustomTopicGrid";
import { fetchSharedWithMe } from "entities/topics/actions";
import {
  createTopicsSelector,
  getSharedWithMeTopicsHasNextPage,
  getSharedWithMeTopicsIsPending,
  getTopicsSharedWithMeIds,
} from "entities/topics/selectors";

const requestLimit = 6 * 8;

const StyledContainer = styled.div`
  padding-top: 3rem;
`;

export const SharedTopicsPage = () => {
  const dispatch = useDispatch();
  const topics = useMemoisedSelector(getTopicsSharedWithMeIds, createTopicsSelector);
  const isPossibleNextPage = useSelector(getSharedWithMeTopicsHasNextPage);
  const isPending = useSelector(getSharedWithMeTopicsIsPending);
  const translate = useTranslate();

  const fetchTopics = (shouldInvalidate = false) => {
    if (!isPending) dispatch(fetchSharedWithMe({ limit: requestLimit, offset: shouldInvalidate ? 0 : topics.length }));
  };

  return (
    <StyledContainer>
      <CustomTopicGrid
        fetchTopics={fetchTopics}
        isFetching={isPending}
        isPossibleNextPage={isPossibleNextPage}
        title={translate("app.create.shared_with_me.title")}
        titleDataTestId="shared-with-me-section-title"
        topicBack={{ term: "app.create.shared_with_me.title" }}
        topics={topics}
      />
    </StyledContainer>
  );
};
